/*
 * DSD p11dz402 maximum social hardening.
 * Adds mobile-first controls around the canonical p11dz401 runtime without
 * changing Firestore, Wasabi, autoplay, preload, or feed ordering authority.
 */
(function(){
  'use strict';
  var root = document.documentElement;
  if (root && root.getAttribute('data-dsd-maximum-social-hardening402-loaded') === 'true') return;
  if (root) root.setAttribute('data-dsd-maximum-social-hardening402-loaded', 'true');

  var VERSION = 'p11dz686-legacy-media-story-owner-deconstructed';
  var OWNER = 'MaximumSocialHardening';

  function qs(sel, root){ try { return (root || document).querySelector(sel); } catch(e){ return null; } }
  function qsa(sel, root){ try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch(e){ return []; } }
  function dataAttr(name){ return 'data-' + String(name || '').replace(/[A-Z]/g, function(ch){ return '-' + ch.toLowerCase(); }); }
  function getData(el, name){ if (!el) return ''; try { if (el.dataset && el.dataset[name] != null) return el.dataset[name]; } catch(e){} return el.getAttribute ? el.getAttribute(dataAttr(name)) : ''; }
  function setData(el, name, value){ if (!el) return; try { if (el.dataset) { el.dataset[name] = String(value); return; } } catch(e){} if (el.setAttribute) el.setAttribute(dataAttr(name), String(value)); }
  function delData(el, name){ if (!el) return; try { if (el.dataset) delete el.dataset[name]; } catch(e){} if (el.removeAttribute) el.removeAttribute(dataAttr(name)); }
  function social(){ return window.DSDLaunchSocial || null; }
  function currentUser(){
    var api = social();
    try { return api && api.currentUser ? api.currentUser() : {}; } catch(e){ return {}; }
  }
  function html(value){
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(ch){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[ch];
    });
  }
  function claim(surface, meta){
    try {
      var registry = window.DSDRegistry || window.DSDRuntimeRegistry;
      if (registry && typeof registry.claim === 'function') {
        registry.claim(surface, OWNER, Object.assign({ version: VERSION }, meta || {}));
      }
    } catch(e){}
  }
  function isSocialRoute(){
    return document.documentElement.classList.contains('dsd-social-route') || document.body.classList.contains('dsd-social-page');
  }
  function toast(message){
    var node = qs('[data-dsd402-status]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'dsd402-status';
      node.setAttribute('data-dsd402-status', '');
      node.setAttribute('role', 'status');
      document.body.appendChild(node);
    }
    node.textContent = message;
    window.clearTimeout(toast.timer);
    toast.timer = window.setTimeout(function(){ if (node && node.parentNode) node.parentNode.removeChild(node); }, 4200);
  }

  function purgeLegacySocialChrome(){
    if (!isSocialRoute()) return;
    var removed = 0;
    qsa('#icon-bar2, .icon-bar2, .icon-bar, .slider6, .slick-slider').forEach(function(node){
      if (!node || node.closest('.dsd-social-nav397, .dsd-compact-dock397')) return;
      if (node.classList && node.classList.contains('dsd-social-legacy-iconbar-sentinel')) {
        node.remove();
        removed += 1;
        return;
      }
      node.setAttribute('data-dsd402-retired', 'legacy-navigation');
      node.setAttribute('aria-hidden', 'true');
      node.hidden = true;
      removed += 1;
    });
    claim('legacy-social-chrome:retired', { hiddenNodes: removed });
  }

  function markSocialDockActive(){
    if (!isSocialRoute()) return;
    var current = window.location.pathname || '';
    qsa('.dsd-social-nav397 a[href]').forEach(function(link){
      var href = link.getAttribute('href') || '';
      var path = href;
      try { path = new URL(href, window.location.origin).pathname; } catch(e){}
      var active = !!path && path !== '/' && current === path;
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  function enhanceMedia(){
    if (!isSocialRoute()) return;
    if (window.DSDGMOR && typeof window.DSDGMOR.scan === 'function') {
      window.DSDGMOR.scan(document);
    }
    qsa('video').forEach(function(video){
      if (getData(video, 'dsd402MediaReady') === 'true') return;
      setData(video, 'dsd402MediaReady', 'true');
      if (!video.getAttribute('preload')) video.setAttribute('preload', 'metadata');
      video.setAttribute('playsinline', '');
      video.playsInline = true;
      if (!video.hasAttribute('data-dsd-video-controls-user-enabled')) {
        video.controls = false;
        video.removeAttribute('controls');
      }
      video.style.objectFit = video.style.objectFit || 'contain';
    });
    qsa('.dsd-launch-media-grid img, .dsd-post-media img').forEach(function(img){
      if (getData(img, 'dsd402MediaReady') === 'true') return;
      setData(img, 'dsd402MediaReady', 'true');
      img.loading = img.loading || 'lazy';
      img.decoding = img.decoding || 'async';
    });
  }

  function enhanceComposers(){
    if (!isSocialRoute()) return;
    qsa('.dsd-post-composer.dsd-canonical-composer').forEach(function(form){
      if (getData(form, 'dsd407ComposerReady') === 'true') return;
      setData(form, 'dsd407ComposerReady', 'true');
      if (form.hasAttribute('data-dsd-profile-inline-post-composer') || form.hasAttribute('data-dsd-canonical-compact-composer')) {
        form.classList.remove('dsd402-composer-collapsed');
        qsa('[data-dsd402-composer-collapse]', form).forEach(function(button){ button.remove(); });
        claim('compact-composer:legacy-collapse-disabled', { owner: form.hasAttribute('data-dsd-feed-inline-post-composer') ? 'LaunchSocialActivation.FeedInlineComposer' : 'LaunchSocialActivation.ProfileInlineComposer' });
        return;
      }
      var body = qs('textarea[name="body"]', form);
      if (body && !body.getAttribute('placeholder')) body.setAttribute('placeholder', "What's happening?");
      var collapse = document.createElement('button');
      collapse.type = 'button';
      collapse.className = 'dsd402-composer-collapse';
      collapse.setAttribute('data-dsd402-composer-collapse', '');
      collapse.textContent = 'Minimize composer';
      form.appendChild(collapse);
      function hasDraft(){
        return qsa('textarea, input[type="text"]', form).some(function(input){ return String(input.value || '').trim(); }) ||
          qsa('input[type="file"]', form).some(function(input){ return input.files && input.files.length; });
      }
      function collapseComposer(){ if (!hasDraft()) form.classList.add('dsd402-composer-collapsed'); }
      form.addEventListener('focusin', function(){ form.classList.remove('dsd402-composer-collapsed'); });
      form.addEventListener('reset', function(){ window.setTimeout(collapseComposer, 0); });
      collapse.addEventListener('click', function(){
        if (hasDraft()) { toast('Clear the draft before minimizing.'); return; }
        form.classList.add('dsd402-composer-collapsed');
        if (body) body.blur();
      });
      collapseComposer();
    });
  }

  function openCommentModal(card, trigger){
    if (!card) return;
    var postId = card.getAttribute('data-post-id') || '';
    var api = social();
    if (api && typeof api.openPostDrawer === 'function') {
      api.openPostDrawer('comments', postId, trigger || null);
      claim('comments:delegated-to-canonical-drawer', { postId: postId, removedOwner: 'MaximumSocialHardening.inlineComments' });
    }
  }

  function openStoryPreviewModal(storyButton){
    if (!storyButton) return;
    var storyId = storyButton.getAttribute('data-dsd-view-story') || '';
    var api = social();
    if (api && typeof api.openStory === 'function') {
      api.openStory(storyId);
      claim('story-preview-modal:delegated-to-canonical-viewer', { storyId: storyId, removedOwner: 'MaximumSocialHardening' });
      return;
    }
    window.location.href = '/pages/stories' + (storyId ? ('?story=' + encodeURIComponent(storyId)) : '');
  }

  function closePanels(card){
    qsa('[data-dsd402-panel]', card || document).forEach(function(panel){ panel.remove(); });
  }
  function openEditPanel(card, postId){
    if (!card || !postId) return;
    closePanels(card);
    var source = qs('p', card);
    var panel = document.createElement('section');
    panel.className = 'dsd402-panel';
    panel.setAttribute('data-dsd402-panel', 'edit-post');
    panel.innerHTML = '<label>Edit post<textarea rows="4" data-dsd402-edit-body maxlength="5000">' + html(source ? source.textContent : '') + '</textarea></label><div class="dsd402-panel__actions"><button type="button" data-dsd402-cancel>Cancel</button><button type="button" data-dsd402-save-edit>Submit edit</button></div>';
    var actions = qs('.dsd-launch-actions', card) || card;
    actions.insertAdjacentElement('afterend', panel);
    var textarea = qs('[data-dsd402-edit-body]', panel);
    if (textarea) textarea.focus();
    qs('[data-dsd402-cancel]', panel).addEventListener('click', function(){ panel.remove(); });
    qs('[data-dsd402-save-edit]', panel).addEventListener('click', function(){
      var api = social();
      var text = textarea ? textarea.value : '';
      if (!api || typeof api.editPost !== 'function') { toast('Post editing is not ready yet.'); return; }
      api.editPost(postId, { body: text, caption: '' }).then(function(){ panel.remove(); toast('Post edit submitted for review.'); });
    });
  }
  function openDeletePanel(card, postId){
    if (!card || !postId) return;
    closePanels(card);
    var panel = document.createElement('section');
    panel.className = 'dsd402-panel';
    panel.setAttribute('data-dsd402-panel', 'delete-post');
    panel.innerHTML = '<strong>Delete this post?</strong><p>This hides the post from social feeds and records the action for founder audit.</p><div class="dsd402-panel__actions"><button type="button" data-dsd402-cancel>Cancel</button><button type="button" data-dsd402-confirm-delete>Delete</button></div>';
    var actions = qs('.dsd-launch-actions', card) || card;
    actions.insertAdjacentElement('afterend', panel);
    qs('[data-dsd402-cancel]', panel).addEventListener('click', function(){ panel.remove(); });
    qs('[data-dsd402-confirm-delete]', panel).addEventListener('click', function(){
      var api = social();
      if (!api || typeof api.deletePost !== 'function') { toast('Post deletion is not ready yet.'); return; }
      api.deletePost(postId).then(function(){ panel.remove(); toast('Post deleted.'); });
    });
  }

  function bindInlinePostActions(){
    if (document.documentElement.getAttribute('data-dsd402-post-actions-bound') === 'true') return;
    document.documentElement.setAttribute('data-dsd402-post-actions-bound', 'true');
    document.addEventListener('click', function(ev){
      var edit = ev.target.closest('[data-dsd-edit-post]');
      var del = ev.target.closest('[data-dsd-delete-post]');
      if (!edit && !del) return;
      var button = edit || del;
      var card = button.closest('[data-post-id], .dsd-post-card');
      var postId = button.getAttribute(edit ? 'data-dsd-edit-post' : 'data-dsd-delete-post') || (card && card.getAttribute('data-post-id'));
      ev.preventDefault();
      ev.stopPropagation();
      ev.stopImmediatePropagation();
      if (edit) openEditPanel(card, postId);
      else openDeletePanel(card, postId);
    }, true);

    document.addEventListener('click', function(ev){
      var comment = ev.target.closest('[data-dsd-action="comment"]');
      if (!comment) return;
      var card = comment.closest('.dsd-post-card, article[data-post-id]');
      if (!card) return;
      var api = social();
      if (api && typeof api.openPostDrawer === 'function') {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        openCommentModal(card, comment);
      }
    }, true);
  }

  function gateDiagnostics(){
    var user = currentUser();
    var allowed = !!(user && user.canModerate);
    var launcher = qs('#dsd-forensics-manual-launcher-p11dz278');
    if (launcher) {
      launcher.classList.toggle('dsd402-diagnostics-hidden', !allowed);
      launcher.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      launcher.disabled = !allowed;
    }
    claim('diagnostics:role-gated', { visible: allowed, roles: user.roles || [] });
  }

  function annotateMultiverseForms(){
    qsa('[data-dsd-mv395]').forEach(function(root){
      var writable = root.classList.contains('dsd-mv395--auth-ready');
      qsa('[data-dsd-mv-create], [data-dsd-mv-chat-form], [data-dsd-mv-story-form]', root).forEach(function(form){
        var memberLocked = form.classList.contains('is-disabled');
        form.setAttribute('aria-hidden', writable ? 'false' : 'true');
        form.querySelectorAll('input, textarea, select, button').forEach(function(control){
          control.disabled = !writable || memberLocked;
        });
      });
      var createForm = qs('[data-dsd-mv-create]', root);
      if (createForm && getData(createForm, 'dsd407CollapsedReady') !== 'true') {
        setData(createForm, 'dsd407CollapsedReady', 'true');
        createForm.classList.add('dsd402-mv-create-collapsed');
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dsd402-mv-create-toggle';
        toggle.setAttribute('data-dsd402-mv-create-toggle', '');
        toggle.setAttribute('aria-expanded', 'false');
        var heading = qs('h2', createForm);
        toggle.textContent = heading ? heading.textContent : 'Create space';
        createForm.parentNode.insertBefore(toggle, createForm);
        toggle.addEventListener('click', function(){
          var opening = createForm.classList.contains('dsd402-mv-create-collapsed');
          createForm.classList.toggle('dsd402-mv-create-collapsed', !opening);
          toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
          if (opening) { var first = qs('input[name="name"]', createForm); if (first) first.focus(); }
        });
        createForm.addEventListener('reset', function(){
          window.setTimeout(function(){ createForm.classList.add('dsd402-mv-create-collapsed'); toggle.setAttribute('aria-expanded', 'false'); }, 0);
        });
      }
      var createToggle = qs('[data-dsd402-mv-create-toggle]', root);
      if (createToggle) createToggle.hidden = !writable;
    });
  }

  function reconcile(){
    purgeLegacySocialChrome();
    markSocialDockActive();
    enhanceMedia();
    enhanceComposers();
    gateDiagnostics();
    annotateMultiverseForms();
  }

  function boot(){
    bindInlinePostActions();
    reconcile();
    window.addEventListener('dsd:launch-social:ready', reconcile);
    window.addEventListener('dsd:launch-social:notifications', gateDiagnostics);
    window.addEventListener('dsd:firebase-module-bridge:ready', function(){ window.setTimeout(reconcile, 50); });
    var observerRoot = qs('#MainContent') || document.body;
    var mo = new MutationObserver(function(records){
      var relevant = (records || []).some(function(record){
        return Array.prototype.some.call(record.addedNodes || [], function(node){
          if (!node || node.nodeType !== 1) return false;
          return node.matches && node.matches('video,img,[data-dsd-media-id],.dsd-post-card,[data-dsd-canonical-composer],[data-dsd-mv395]') || node.querySelector && node.querySelector('video,img,[data-dsd-media-id],.dsd-post-card,[data-dsd-canonical-composer],[data-dsd-mv395]');
        });
      });
      if (!relevant) return;
      window.clearTimeout(boot.timer);
      boot.timer = window.setTimeout(reconcile, 180);
    });
    if (observerRoot) mo.observe(observerRoot, { childList: true, subtree: true });
    claim('maximum-social-hardening:ready', { socialRoute: isSocialRoute() });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  try {
    window.DSDMaximumSocialHardening402 = { version: VERSION, reconcile: reconcile, focusComments: openCommentModal, openStoryPreviewModal: openStoryPreviewModal };
  } catch(e) {
    try { document.DSDMaximumSocialHardening402 = { version: VERSION, reconcile: reconcile, focusComments: openCommentModal, openStoryPreviewModal: openStoryPreviewModal }; } catch(ignore) {}
  }
})();
